import ModalStore from "@src/stores/Component/ModalStore";

class ProfilePhotosModalStore extends ModalStore {
	constructor(rootStore, staticContext) {
		super({ maxWidth: "md" });
		this.rootStore = rootStore;
	}

	onClose() {
		super.onClose();
	}
}

export default ProfilePhotosModalStore;
